import { ArcLayer } from 'deck.gl';
import { PARAMETROS_ADITIVOS } from './pulso';

const COLOR_ARCO = [255, 213, 74];
// El arco es un haz de barrido: aparece cuando el frente alcanza el servicio
// y se apaga pocos minutos despues, en vez de quedar encendido todo el
// escaneo. Asi solo se ve la banda recien alcanzada y los arcos no se apilan
// hasta saturar a blanco; el estado en reposo lo dan los puntos, no las lineas.
const VENTANA_ESTELA = 4.5; // minutos que el arco tarda en apagarse tras ser alcanzado
const PICO_OPACIDAD = 0.5;

function opacidadPorTiempo(minutos, t) {
  const trasElFrente = t - minutos;
  if (trasElFrente < 0 || trasElFrente > VENTANA_ESTELA) return 0;
  const factor = 1 - trasElFrente / VENTANA_ESTELA;
  return Math.round(PICO_OPACIDAD * factor * 255);
}

// "amenitiesPorIdx" llega memoizado desde App: construir el Map aqui lo
// recrearia en cada frame de la animacion.
export function construyeCapaArcos({ origenPos, amenitiesPorIdx, alcanzables = [], t }) {
  if (!origenPos) return null;

  const arcos = alcanzables
    .filter(([, minutos]) => minutos <= t && t - minutos <= VENTANA_ESTELA)
    .map(([idx, minutos]) => {
      const destino = amenitiesPorIdx.get(idx);
      if (!destino) return null;
      return { targetPos: [destino.lon, destino.lat], minutos };
    })
    .filter((arco) => arco !== null);

  return new ArcLayer({
    id: 'arcos',
    data: arcos,
    parameters: PARAMETROS_ADITIVOS,
    getSourcePosition: () => origenPos,
    getTargetPosition: (d) => d.targetPos,
    getSourceColor: (d) => [...COLOR_ARCO, opacidadPorTiempo(d.minutos, t)],
    getTargetColor: (d) => [...COLOR_ARCO, opacidadPorTiempo(d.minutos, t)],
    getWidth: 2,
    updateTriggers: {
      getSourcePosition: [origenPos],
      getSourceColor: [t],
      getTargetColor: [t],
    },
  });
}
